theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      /* Add a Button For SubMenu Toggle */
      offcanvasMenu.forEach((item) => {
        item
        .querySelectorAll(".offcanvas__sub_menu")
        .forEach(function (ul) {
          const subMenuToggle = document.createElement("button");
          subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
          subMenuToggle.setAttribute("aria-label", "menu collapse");
          ul.parentNode.appendChild(subMenuToggle);
        });


      });
      
      /* Open/Close Menu On Click Toggle Button */
      offcanvasOpen.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.add("open");
        body.style.overflowY = "hidden";
      });
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.remove("open");
        body.style.overflowY = null;
      });
      
      
      /* Toggle submenu function */
      const toggleSubmenu = function(menuLi) {
        const subMenu = menuLi.querySelector(".offcanvas__sub_menu");
        const toggle = menuLi.querySelector(".offcanvas__sub_menu_toggle");
        
        if (!subMenu) return;
        
        if (menuLi.classList.contains("active")) {
          // Close submenu
          if (toggle) toggle.classList.remove("active");
          menuLi.classList.remove("active");
          slideUp(subMenu);
        } else {
          // Open submenu
          if (toggle) toggle.classList.add("active");
          menuLi.classList.add("active");
          slideDown(subMenu);
          
          // Close other open submenus (accordion behavior)
          getSiblings(menuLi).forEach(function (item) {
            item.classList.remove("active");
            const siblingSubMenu = item.querySelector(".offcanvas__sub_menu");
            const siblingToggle = item.querySelector(".offcanvas__sub_menu_toggle");
            if (siblingSubMenu) {
              slideUp(siblingSubMenu);
            }
            if (siblingToggle) {
              siblingToggle.classList.remove("active");
            }
          });
        }
      };

      /* Prevent navigation on menu items with submenus and toggle instead */
      offcanvasMenu.forEach((offcanvasMenuitem) => {
        offcanvasMenuitem
        .querySelectorAll(".offcanvas__menu_li")
        .forEach(function (menuLi) {
          const subMenu = menuLi.querySelector(".offcanvas__sub_menu");
          const menuItemLink = menuLi.querySelector(".offcanvas__menu_item");
          
          // Only prevent navigation if there's a submenu
          if (subMenu && menuItemLink) {
            menuItemLink.addEventListener("click", function (e) {
              e.preventDefault();
              toggleSubmenu(menuLi);
            });
          }
        });
      });

      /* Open/Close Sub Menu On Click Toggle Button */
      offcanvasMenu.forEach((offcanvasMenuitem) => {
        offcanvasMenuitem
        .querySelectorAll(".offcanvas__sub_menu_toggle")
        .forEach(function (toggle) {
          toggle.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation(); // Prevent event from bubbling to the link
            const menuLi = this.parentElement;
            toggleSubmenu(menuLi);
          });
        });                   
      })
      

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            offcanvasHeader.classList.remove("open");
            body.style.overflowY = null;
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992) {
          offcanvasHeader.classList.remove("open");
          body.style.overflowY = null;
        }
      });
    };
    /* Mobile Menu Active */
    offcanvasHeader();
  }

  return header;
})();